(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-order-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-order-details')) {
    customElements.define(
      'custom-order-details',
      class CustomOrderDetails extends HTMLElement {
        constructor() {
          super();
          this.productForm = null;
          this.inputs = Array.from(this.querySelectorAll('[data-custom-order-input]'));
          this.fileInputs = Array.from(this.querySelectorAll('[data-custom-order-file]'));
        }

        connectedCallback() {
          // Wait a tick so <product-form> has finished upgrading.
          requestAnimationFrame(() => this.wireUp());
        }

        wireUp() {
          this.productForm = document.querySelector('product-form form[id^="product-form-"]:not([id*="installment"])');

          if (!this.productForm) {
            setTimeout(() => {
              this.productForm = document.querySelector('product-form form[id^="product-form-"]:not([id*="installment"])');
              if (this.productForm) this.attachInputs();
            }, 200);
            return;
          }

          this.attachInputs();
        }

        attachInputs() {
          // Bind file inputs (previews, drag & drop, size validation).
          this.fileInputs.forEach((input) => this.bindFileInput(input));

          // Hook the `formdata` event on the product form. This event fires
          // synchronously inside `new FormData(this.productForm)` — which is
          // exactly what product-form.js uses when submitting to /cart/add.js.
          // We inject each of our fields into the FormData at that moment, so
          // they're guaranteed to reach the cart as line item properties.
          this.productForm.addEventListener('formdata', (event) => this.injectProperties(event));

          // Also block submission if any file exceeds its max size.
          this.productForm.addEventListener('submit', (event) => this.validateFilesOnSubmit(event), true);
        }

        injectProperties(event) {
          this.inputs.forEach((input) => {
            if (!input.name || !input.name.startsWith('properties[')) return;
            if (input.disabled) return;

            if (input.type === 'file') {
              const files = input.files ? Array.from(input.files) : [];
              files.forEach((file) => event.formData.append(input.name, file, file.name));
            } else if (input.type === 'checkbox') {
              if (input.checked) event.formData.append(input.name, input.value);
            } else if (input.type === 'radio') {
              if (input.checked) event.formData.append(input.name, input.value);
            } else {
              // Text, textarea, select.
              const value = input.value != null ? String(input.value).trim() : '';
              if (value !== '') event.formData.append(input.name, value);
            }
          });
        }

        bindFileInput(input) {
          const wrapper = input.closest('.custom-order-details__block');
          if (!wrapper) return;

          const dropzone = wrapper.querySelector('[data-dropzone]');
          const nameEl = wrapper.querySelector('[data-file-name]');
          const errorEl = wrapper.querySelector('[data-file-error]');
          const previewEl = wrapper.querySelector('[data-preview]');

          input.addEventListener('change', () => this.handleFiles(input, { dropzone, nameEl, errorEl, previewEl }));

          if (!dropzone) return;

          const stop = (e) => {
            e.preventDefault();
            e.stopPropagation();
          };

          ['dragenter', 'dragover'].forEach((evt) => {
            dropzone.addEventListener(evt, (e) => {
              stop(e);
              dropzone.classList.add('is-dragover');
            });
          });

          ['dragleave', 'dragend'].forEach((evt) => {
            dropzone.addEventListener(evt, (e) => {
              stop(e);
              dropzone.classList.remove('is-dragover');
            });
          });

          dropzone.addEventListener('drop', (e) => {
            stop(e);
            dropzone.classList.remove('is-dragover');
            if (!e.dataTransfer || !e.dataTransfer.files || e.dataTransfer.files.length === 0) return;

            try {
              const dt = new DataTransfer();
              const useMultiple = input.multiple;
              const files = Array.from(e.dataTransfer.files);
              (useMultiple ? files : files.slice(0, 1)).forEach((f) => dt.items.add(f));
              input.files = dt.files;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            } catch (err) {
              this.showError(errorEl, 'Drag & drop not supported — please click to choose a file.');
            }
          });
        }

        handleFiles(input, { dropzone, nameEl, errorEl, previewEl }) {
          this.clearError(errorEl);
          if (previewEl) {
            previewEl.innerHTML = '';
            previewEl.hidden = true;
          }

          const files = Array.from(input.files || []);
          if (files.length === 0) {
            if (nameEl) nameEl.textContent = 'No file selected';
            if (dropzone) dropzone.classList.remove('has-file');
            return;
          }

          const oversize = this.getOversizeFiles(input, files);
          if (oversize.length > 0) {
            this.showError(
              errorEl,
              `${oversize.map((f) => f.name).join(', ')} exceeds the max file size (${input.dataset.maxSizeMb}MB).`
            );
            input.value = '';
            if (nameEl) nameEl.textContent = 'No file selected';
            if (dropzone) dropzone.classList.remove('has-file');
            return;
          }

          if (nameEl) {
            nameEl.textContent =
              files.length === 1 ? files[0].name : `${files.length} files selected`;
          }
          if (dropzone) dropzone.classList.add('has-file');

          if (previewEl) {
            previewEl.hidden = false;
            files.forEach((file) => previewEl.appendChild(this.buildPreview(file)));
          }
        }

        buildPreview(file) {
          const item = document.createElement('div');
          item.className = 'custom-order-details__preview-item';

          if (file.type && file.type.startsWith('image/')) {
            const img = document.createElement('img');
            img.alt = file.name;
            const reader = new FileReader();
            reader.onload = (e) => {
              img.src = e.target.result;
            };
            reader.readAsDataURL(file);
            item.appendChild(img);
          } else {
            item.classList.add('custom-order-details__preview-item--file');
            const span = document.createElement('span');
            span.textContent = file.name;
            item.appendChild(span);
          }
          return item;
        }

        getOversizeFiles(input, files) {
          const maxMb = parseFloat(input.dataset.maxSizeMb || '20');
          const maxBytes = maxMb * 1024 * 1024;
          return files.filter((f) => f.size > maxBytes);
        }

        validateFilesOnSubmit(event) {
          let hasError = false;

          this.fileInputs.forEach((input) => {
            const files = Array.from(input.files || []);
            if (files.length === 0) return;
            const oversize = this.getOversizeFiles(input, files);
            if (oversize.length > 0) {
              hasError = true;
              const wrapper = input.closest('.custom-order-details__block');
              const errorEl = wrapper ? wrapper.querySelector('[data-file-error]') : null;
              this.showError(
                errorEl,
                `${oversize.map((f) => f.name).join(', ')} exceeds the max file size (${input.dataset.maxSizeMb}MB).`
              );
              input.value = '';
            }
          });

          if (hasError) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }

        showError(el, message) {
          if (!el) return;
          el.textContent = message;
          el.hidden = false;
        }

        clearError(el) {
          if (!el) return;
          el.textContent = '';
          el.hidden = true;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
